import React from 'react';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {unpackId} from 'common/diplomatIdUtil';
import MoveDialog from 'features/layout/DialogRoutes/dialogs/MoveDialog';
import {DialogTypes} from 'common/names';
import {useDispatch} from 'react-redux';
import {sftpUsersActions} from 'redux/sftp-user';

type Props = {
   data: INav;
   onClose: () => void;
};

const MoveSftpUserDialog = ({data, onClose}: Props) => {
   const {id} = unpackId(data.id);
   const dispatch = useDispatch();

   const handleMove = (folderId: string) => {
      dispatch(
         sftpUsersActions.moveSftpUser([id], folderId, {
            onSuccess: onClose,
            onError: onClose,
         })
      );
   };

   return (
      <MoveDialog
         data={data}
         header={DialogTypes.MoveSftpUserDialog.dialogName}
         onConfirm={handleMove}
         onClose={onClose}
      />
   );
};

export default MoveSftpUserDialog;
